import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { TimeTrackRoute } from "./TimeTrackRoute";
import TimeTrackRouteQueryNode, {
  type TimeTrackRouteQuery$variables,
} from "./__generated__/TimeTrackRouteQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof TimeTrackRoute> = {
  root: JSResource("TimeTrackRoute", () =>
    import("./TimeTrackRoute").then((module) => module.TimeTrackRoute),
  ),
  getPreloadProps({ params }) {
    const variables: TimeTrackRouteQuery$variables = {
      id: params.id!,
    };

    return {
      queries: {
        query: {
          parameters: TimeTrackRouteQueryNode,
          variables,
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
